import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import AccountFilter from "components/common/filters/account/AccountFilter";
import { Close } from "@mui/icons-material";
import {
  ADVISORY_OPTIONS,
  DISCONNECTED_DATE_ORDER_OPTIONS,
  MONTHLY_BATTERY_CHECK_OPTIONS,
} from "static/constants";

const LiveCallTaskSearchFilter = ({
  handleSearchPatient,
  handleAccountFilter,
  selectedAccount,
  patientNameSearch,
  selectedAdvisory,
  handleAdvisoryFilter,
  selectedMonthlyBatteryCheck,
  handleMonthlyBatteryCheckFilter,
  selectedDisconnectedDateOrder,
  handleDisconnectedDateOrder,
}) => {
  return (
    <div style={{ padding: "12px 24px", borderBottom: "1px solid #E0E0E0" }}>
      <Grid container spacing={1}>
        <Grid item md={4}>
          <TextField
            fullWidth
            variant="outlined"
            value={patientNameSearch}
            placeholder="Search Patients"
            onChange={handleSearchPatient}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              endAdornment: patientNameSearch && (
                <InputAdornment position="end">
                  <IconButton onClick={() => handleSearchPatient()} edge="end">
                    <Close />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={2}>
          <AccountFilter
            label="Accounts"
            displayAll={true}
            required={false}
            value={selectedAccount}
            onChange={handleAccountFilter}
          />
        </Grid>
        <Grid item md={2}>
          <FormControl fullWidth>
            <InputLabel id="advisory-filter-label">Advisory</InputLabel>
            <Select
              labelId="advisory-filter-label"
              id="advisory-filter"
              value={selectedAdvisory}
              label="Advisory"
              onChange={handleAdvisoryFilter}
            >
              {ADVISORY_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <FormControl fullWidth>
            <InputLabel id="monthly-battery-check-filter-label">
              Monthly Battery Check
            </InputLabel>
            <Select
              labelId="monthly-battery-check-filter-label"
              id="monthly-battery-check-filter"
              value={selectedMonthlyBatteryCheck}
              label="Monthly Battery Check"
              onChange={handleMonthlyBatteryCheckFilter}
            >
              {MONTHLY_BATTERY_CHECK_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={2}>
          <FormControl fullWidth>
            <InputLabel id="disconnected-date-order-label">
              Disconnected Date
            </InputLabel>
            <Select
              labelId="disconnected-date-order-label"
              id="disconnected-date-order"
              value={selectedDisconnectedDateOrder}
              label="Disconnected Date"
              onChange={handleDisconnectedDateOrder}
            >
              {DISCONNECTED_DATE_ORDER_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

export default LiveCallTaskSearchFilter;
